import EnCountry from '@/data/countries.json'
import CnCountry from '@/data/countries_cn.json'

function updateVideoList(state) {
    let videos = Object.keys(state.videoDict).map(function(key) {
        return state.videoDict[key]
    })
    let listCN = []
    videos.sort((a, b) => (a.update_timestamp > b.update_timestamp) ? -1 : 1)
    state.videoList = videos
    videos.map(item => {
        if (item.source !== 'youtube') {
            listCN.push(item)
        }
    })
    state.videoListCN = listCN
}

export const SET_VIDEO_DICT = (state, videoDict) => {
    state.videoDict = videoDict
    updateVideoList(state)
}

export const SET_SHARING_VIDEO_URL = (state, url) => {
    state.sharingVideoURL = url
}

export const SET_GIVE_PETAL_VIDEO = (state, video) => {
    state.givePetalVideo = video
}

export const ADD_VIDEOS = (state, videos) => {
    state.country = videos[1]
    let videoList = videos[0] || []
    videoList.forEach(function(video) {
        if (video.hasOwnProperty('id')) {
            let id = video['id']
            state.videoDict[id] = video
        }
    })
    updateVideoList(state)
}

export const CLOSE_POSTER = (state) => {
    state.isShowPoster = false
}

export const SET_COUNTRY_DATA = (state, lang) => {
    if (lang === 'cn') {
        state.countryData = CnCountry
    } else {
        state.countryData = EnCountry
    }
    state.countryDict = state.countryData.reduce(function(map, obj) {
        map[obj.alpha3] = obj.country
        return map
    }, {})
}

export const SET_USER_INFO = (state, userInfo) => {
    state.userInfo = userInfo
    state.userBalance = userInfo['balance']
    state.nextDailyRewardTime = userInfo['next_reward']
}

export const SET_USER_BALANCE = (state, balance) => {
    state.userBalance = balance
    state.userInfo['balance'] = balance
}

export const SET_USER_NEXT_REWARD_TS = (state, timestamp) => {
    state.nextDailyRewardTime = timestamp
    state.userInfo['next_reward'] = timestamp
}

export const SET_CURRENT_SELECT_VIDEO = (state, video) => {
    state.currentSelectVideo = video
}

export const SWAP_VIDEOS_IN_LIST = (state, [videoIndex1, videoIndex2]) => {
    if (!videoIndex1 || !videoIndex2 || videoIndex1 === videoIndex2) {
        return
    }
    if (videoIndex2 < videoIndex1) {
        let temp = videoIndex1
        videoIndex1 = videoIndex2
        videoIndex2 = temp
    }
    if (videoIndex2 >= state.videoList.length || videoIndex1 < 0) {
        return
    }
    let video2 = state.videoList.splice(videoIndex2, 1)
    let video1 = state.videoList.splice(videoIndex1, 1, video2[0])
    state.videoList.splice(videoIndex2, 0, video1[0])
}

export const SET_ACTIVE_POINT = (state, ap) => {
    state.activePoint = parseFloat(ap)
    localStorage.setItem('user_ap', ap)
}

export const ADD_ACTIVE_POINT = (state, ap) => {
    if (!state.activePoint) {
        state.activePoint = parseFloat(ap)
    } else {
        state.activePoint = parseFloat(state.activePoint) + parseFloat(ap)
    }
    localStorage.setItem('user_ap', state.activePoint)
}

export const SET_SHARED_VIDEO_COUNT = (state, num) => {
    state.sharedVideoCount = num
    localStorage.setItem('shared_video_count', num)
}

export const SET_LANGUAGE_SEARCH_LABEL = (state, language) => {
    state.searchLanguage = language
}

export const SET_LANGUAGE_SEARCH_SUBTITLE_LABEL = (state, language) => {
    state.searchSubtitleLanguage = language
}

export const SET_CATEGORY_SEARCH_LABEL = (state, category) => {
    state.searchCategory = category
}
export const SET_SUBCATEGORY_SEARCH_LABEL = (state, subcategory) => {
    state.searchSubCategory = subcategory
}

export const SET_CHANGE_NAVBAR_STYLE = (state, result) => {
    state.isChangeNavBarStyle = result
}

export const SET_IS_PC_CLIENT = (state, result) => {
    state.isPcClient = result
}



// WEBPACK FOOTER //
// ./src/store/mutations.js